import { DateRange, TimePicker } from '@blueprintjs/datetime';
import * as React from 'react';

import { isValidDate } from 'bones/utils/dates/isValidDate';
import {
  getDateFromXsdTimeString,
  getXsdTimeStringFromDate,
} from 'bones/utils/dates/xsdFormat';

export interface TimeRangeInputProps {
  dateSplitSymbol: string;
  onSetValue: (value: string) => void;
  testId?: string;
  value: string | null;
}

export const TimeRangeInput: React.VFC<TimeRangeInputProps> = ({
  dateSplitSymbol,
  onSetValue,
  testId,
  value,
}) => {
  const times: DateRange = value
    ? (value.split(dateSplitSymbol).map((timeString) => {
        const date = getDateFromXsdTimeString(timeString || '');
        return isValidDate(date) ? date : null;
      }) as DateRange)
    : [null, null];

  const setValues = (minTime: Date | null, maxTime: Date | null) => {
    const joinedTimes = `${
      minTime ? getXsdTimeStringFromDate(minTime) : ''
    }${dateSplitSymbol}${maxTime ? getXsdTimeStringFromDate(maxTime) : ''}`;
    onSetValue(joinedTimes);
  };

  return (
    <div className="sd-input-time-range" data-testid={testId}>
      <TimePicker
        onChange={(minDate) => setValues(minDate, times[1])}
        useAmPm
        value={times[0] ? new Date(times[0]) : null}
      />
      <TimePicker
        onChange={(maxDate) => setValues(times[0], maxDate)}
        useAmPm
        value={times[1] ? new Date(times[1]) : null}
      />
    </div>
  );
};
